<template>
  <div class="row">
    <!-- Sub programm -->
    <div class="col-md-4 mb-3">
      <div class="sub-programmes sub">
        <div class="text-center crd-title">
          <div class="heading">SUB PROGRAMME</div>
        </div>

        <div class="mb-5">
          <ul class="mt-2 list-ul pr-0 pl-0">
            <div class="p-3 mb-2">
              <input
                type="text"
                placeholder="Search..."
                v-model="searchQuerySubProgram"
                class="search_button form-control form-control-sm"
              />
            </div>

            <div>
              <div
                v-for="(item, index) in subProgramFilter"
                :key="item.id"
                :class="['card', { 'active-card': active_sp === item.id }]"
                class="mb-2 pt-2 pb-2 sub-card"
                @click="showProjects(item.id)"
              >
                <div class="d-sm-flex justify-content-between">
                  <div class="d-sm-flex">
                    <div>
                      <div class="title_name">{{ item.title }}</div>
                      <div class="details">
                        Total Projects: {{ item.project.length }}
                      </div>
                      <div class="trainingCount">
                        Trainings Count
                      </div>
                      <div>
                        <span class="status status-planned"
                          >Planned {{item?.InQueue ?? 0}}</span
                        >
                        <span class="status status-in-progress"
                          >In-Progress {{item?.InProgress ?? 0}}</span
                        >
                        <span class="status status-completed"
                          >Completed {{item?.Completed ?? 0}}</span
                        >
                        <span>
                          <b class="sp">{{ item.code }}</b>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="align-self-center">
                    <i class="material-icons large clr-orange">play_arrow</i>
                  </div>
                </div>
              </div>
            </div>

            <!-- li ends -->
          </ul>
        </div>
      </div>

      <!-- ----------------------------------- -->

      <div class="mt-2 text-center"  v-if="userRole === 'admin'">
        <a @click="$bvModal.show('bv-modal-example')">
          <span class="open-modal">+ Add New Sub Programme</span>
        </a>

        <b-modal id="bv-modal-example" hide-footer hide-header>
          <form @submit.prevent="submitSubProgram">
            <div style="padding: 40px">
              <h5 class="text-center">Add Sub Programme</h5>
              <div class="d-block mt-2">
                <div class="form-group">
                  <label class="font-weight-bold">Sub Program</label>
                  <input
                    type="text"
                    v-model="newSubProgram.title"
                    class="form-control"
                    placeholder="Enter title"
                  />
                </div>
                <div class="form-group">
                  <label class="font-weight-bold">Code</label>
                  <input
                    type="text"
                    v-model="newSubProgram.code"
                    class="form-control"
                    placeholder="Enter code"
                  />
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <b-button
                  type="submit"
                  class="mt-3 mr-1 modal-btn"
                  variant="primary"
                  >Submit</b-button
                >
                <b-button
                  variant="outline-primary"
                  class="mt-3 ml-1 modal-btn"
                  @click="$bvModal.hide('bv-modal-example'); resetForm();"
                  >Cancel</b-button
                >
              </div>
            </div>
          </form>
        </b-modal>
      </div>
    </div>

    <!-- Projects -->
    <transition name="slide">
      <div class="col-md-4 mb-3" id="projectDiv" v-if="this.projectDiv == true">
        <div class="sub-programmes project">
          <div class="text-center crd-title">
            <div class="heading">PROJECTS</div>
          </div>

          <div class="mb-5">
            <ul class="mt-2 list-ul">
              <div class="p-3 mb-2">
                <input
                  type="text"
                  placeholder="Search..."
                  v-model="searchQueryProject"
                  class="search_button form-control form-control-sm"
                />
              </div>

              <div>
                <div
                  v-for="(item, index) in projectFilter"
                  :key="item.id"
                  :class="['card', { 'active-card': active_pr === item.id }]"
                  class="mb-2 pt-2 pb-2 project-card"
                  @click="showTrainings(item.id, item.subprogram_id)"
                >
                  <div class="d-sm-flex justify-content-between">
                    <div class="d-sm-flex">
                      <div>
                        <div ><span class="title_code">{{ item.code }}</span></div>
                        <div class="title_name">{{ item.title }}</div>
                        <div class="details">
                          Total Trainings: {{ item.training.length }}
                        </div>
                        <div>
                          <span class="status status-planned"
                            >Planned {{item?.InQueue ?? item?.training?.[0]?.InQueue ?? 0}}</span
                          >
                          <span class="status status-in-progress"
                            >In-Progress
                            {{item?.InProgress ?? item?.training?.[0]?.InProgress ?? 0}}</span
                          >
                          <span class="status status-completed"
                            >Completed
                            {{item?.Completed ?? item?.training?.[0]?.Completed ?? 0}}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="align-self-center">
                      <i class="material-icons large clr-green" style
                        >play_arrow</i
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!-- li ends -->
            </ul>
          </div>
        </div>
        <!-- ----------------------------------- -->
        <div class="mt-2 text-center" v-if="userRole === 'admin'">
          <a @click="$bvModal.show('bv-modal-example2')">
            <span class="open-modal">+ Add New Project</span>
          </a>
          <b-modal id="bv-modal-example2" hide-footer hide-header>
            <form @submit.prevent="submitProject">
              <div style="padding: 40px">
                <h5 class="text-center">Add Project</h5>
                <div class="d-block mt-2">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12 form-group">
                        <label>
                          Sub Program
                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <selectize
                          id="select-state"
                          class="text-capitalize"
                          v-model="newProject.subprogram_id"
                          :searchable="true"
                        >
                          <option
                            v-for="(item, index) in subProgramData"
                            :key="index"
                            :value="item.id"
                            class="text-capitalize"
                          >
                            {{ item.title }}
                          </option>
                        </selectize>
                      </div>
                      <div class="col-sm-12 form-group">
                        <label for>
                          Project Code / Agreement Reference
                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <input
                          type="text"
                          v-model="newProject.code"
                          class="form-control"
                          placeholder="Enter code"
                        />
                      </div>

                      <div class="col-sm-12 form-group">
                        <label for>
                          Project Title
                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <input
                          type="text"
                          v-model="newProject.title"
                          class="form-control"
                          placeholder="Enter title"
                        />
                      </div>

                      <div class="col-sm-12 form-group">
                        <label>
                          Start Date
                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <flat-pickr
                          class="form-control"
                          style="background: #fff;font-size:13px"
                          placeholder="Select startdate"
                          v-model="newProject.startDate"
                          :config="dateOptions"
                        ></flat-pickr>
                      </div>
                      <div class="col-sm-12 form-group">
                        <label>
                          End Date
                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <flat-pickr
                          class="form-control"
                          style="background: #fff;font-size:13px"
                          placeholder="Select enddate"
                          v-model="newProject.endDate"
                          :config="newProject.endDate"
                        ></flat-pickr>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <b-button
                    type="submit"
                    class="mt-3 mr-1 modal-btn"
                    variant="primary"
                    >Submit</b-button
                  >
                  <b-button
                    variant="outline-primary"
                    class="mt-3 ml-1 modal-btn"
                    @click="$bvModal.hide('bv-modal-example2'); resetForm();"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </form>
          </b-modal>
        </div>
      </div>
    </transition>
    <!-- trainings -->
    <transition name="slide">
      <div class="col-md-4 mb-3" id="trainingDiv" v-if="this.trainingDiv == true">
        <div class="sub-programmes training">
          <div class="text-center crd-title">
            <div class="heading">Trainings</div>
          </div>

          <div class="mb-5">
            <ul class="mt-2 list-ul">
              <div class="p-3">
                <input
                  type="text"
                  placeholder="Search ..."
                  v-model="searchQueryTraining"
                  class="search_button form-control form-control-sm"
                />
              </div>
              <div class="pl-3 pr-3 mb-2">
                <div class="form-group date-box">
                  <label style="font-weight:700;" for="first">Date Range</label>

                  <flat-pickr
                    class="form-control form-control-sm search_button"
                    style="background: #fff;opacity:1"
                    placeholder="Date Range"
                    v-model="dateRange"
                    :config="cardDateOptions"
                  ></flat-pickr>

                  <button
                    class="btn btn-sm btn-info date-btn"
                    @click="resetTrainingFilter(projectId,subIdMain)"
                  >
                    Reset
                  </button>
                </div>
              </div>

              <!-- li starts -->
              <div>
                <div
                  v-for="(item, index) in trainingFilter"
                  :key="item.id"
                  :class="['card', { 'active-card': active_sp === item.id }]"
                  class="mb-2 pt-2 pb-2 training-card"
                  @click="showsingletrainingreport(item)"
                >
                  <div class="d-sm-flex justify-content-between">
                    <div class="d-sm-flex">
                      <!-- <div class="short-title pr-3 align-self-center">
                            <b class="clr-blue">{{item.training_code}}</b>
                          </div>-->
                      <div class="">
                        <div class="title_name">{{ item.title }}</div>

                        <div class="details">
                          <div>
                            {{ formatDate(item.startdate) }} -
                            {{ formatDate(item.enddate) }} | {{ item.venue }},
                            {{ item.address }}
                          </div>
                          <div>
                            Participants: {{item?.traineeCount ?? 0}}, Trainers:
                            {{item?.trainerCount ?? 0}}
                          </div>
                          <div>
                            <span
                              class="status"
                              :class="enddateStatusClass(item.startdate, item.enddate)"
                            >
                              {{ enddateStatusText(item.startdate, item.enddate) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="align-self-center">
                      <i class="material-icons large clr-blue" style
                        >play_arrow</i
                      >
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
        <!-- ----------------------------------- -->

        <div class="mt-2 text-center" v-if="userRole === 'admin'">
          <a @click="$bvModal.show('bv-modal-example3')">
            <span class="open-modal">+ Add New Training</span>
          </a>
          <b-modal id="bv-modal-example3" hide-footer hide-header>
            <form @submit.prevent="submitTraining">
              <div style="padding: 40px">
                <h5 class="text-center">Add Training</h5>
                <div class="d-block mt-2">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12 form-group">
                        <label>
                          Sub Program
                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <selectize
                          id="select-state"
                          class="text-capitalize"
                          v-model="newTraining.program_id"
                         
                          :searchable="true"
                        >
                          <option
                            v-for="(item, index) in subProgramData"
                            :key="index"
                            :value="item.id"
                            class="text-capitalize"
                          >
                            {{ item.title }}
                          </option>
                        </selectize>
                      </div>
                      <div class="col-sm-12 form-group">
                        <label>
                          Project
                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <selectize
                          id="select-state"
                          class="text-capitalize"
                          v-model="newTraining.project_id"
                          :searchable="true"
                        >
                          <option
                            v-for="(item, index) in projectData"
                            :key="index"
                            :value="item.id"
                            class="text-capitalize"
                          >
                            {{ item.title }}
                          </option>
                        </selectize>
                      </div>
                      <div class="col-sm-12 form-group">
                        <label>
                          Assign To Advisor
                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <selectize
                          id="select-state"
                          class="text-capitalize"
                          v-model="newTraining.advisor_id"
                          :searchable="true"
                        >
                          <option
                            v-for="(item, index) in advisorArr"
                            :key="index"
                            :value="item.id"
                            class="text-capitalize"
                          >
                            {{ item.name }}
                          </option>
                        </selectize>
                      </div>
                      <div class="col-sm-12 form-group">
                        <label for>Training Title</label>
                        <input
                          type="text"
                          v-model="newTraining.trainingtitle"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <b-button
                    type="submit"
                    class="mt-3 mr-1 modal-btn"
                    variant="primary"
                    >Submit</b-button
                  >
                  <b-button
                    variant="outline-primary"
                    class="mt-3 ml-1 modal-btn"
                    @click="$bvModal.hide('bv-modal-example3'); resetForm();"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </form>
          </b-modal>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment';
import Selectize from "vue2-selectize";
import {
    subProgrammes,
    projects,
    trainings
} from '../../utils/DownloadCSV';
import { formatDate } from "@/utils/DateFormate";

export default {
    data() {
        return {
            projectDiv : false,
            trainingDiv: false,
            searchstartDate: '',
            searchendDate: '',
            subProgramData: [],
            projectData: [],
            trainingData: [],
            programOfficerArr: [],
            advisorArr: [],
            searchQuerySubProgram: "",
            searchQueryProject: "",
            searchQueryTraining: "",
            dateRange: [],
            projectId: '',
            programId: '',
            userId: JSON.parse(localStorage.getItem("currentUser")).id,
            userRole: localStorage.getItem("isPermission"),
            cardDateOptions: {
                wrap: true,
                weekNumbers: true,
                mode: "range",
                maxDate: new Date().fp_incr(10),
                dateFormat: "d-m-Y",
            },
            dateOptions: {
                dateFormat: "d-m-Y"
            },
            EnddateOptions: {
                minDate: "today",
                dateFormat: "d-m-Y"
            },
            newSubProgram: {
                title: '',
                code: '',
            },
            newProject: {
                subprogram_id: '',
                code: '',
                title: '',
                startDate: '',
                endDate: '',
            },
            projectTitle: '',
            trainingTitle: '',
            newTraining: {
                program_id: '',
                project_id: '',
                trainingtitle: '',
                advisor_id: '',
            },
            active_sp: 0,
            active_pr: 0,
            active_tr: 0
        };

    },

    components: {
        flatPickr,
        Selectize
    },
    mounted() {

        this.searchSubProgram();
        this.getProgramofficer();
        this.getAdvisor();

    },
    methods: {
      formatDate,
        checkTab() {
            const Project = JSON.parse(sessionStorage.getItem("project"));
            const Training = JSON.parse(sessionStorage.getItem("training"));

             if( Project != null){
                 this.showProjects(Project);
                 this.projectDiv = true;
             }
              if(Training != null){
                 this.showTrainings(Training);
                 this.trainingDiv = true;
             }
        },
        searchSubProgram() {
            this.openLoading();

            axios
            this.fetchSubprograms()
                .then((response) => {
                    this.closeLoading();
                    this.checkTab();
                    this.subProgramData = response.data
                })
                .catch((error) => console.error("Error fetching Sub Programs:", error));
        },
        fetchSubprograms() {
            const BASE_PATH = localStorage.getItem("BASE_PATH");
            const userRole = this.userRole;
            const userId = this.userId;

            // Determine the endpoint based on user role
            let endpoint = "";

            switch (userRole) {
                case "admin":
                    endpoint = "/subprograms/get";
                    break;
                case "advisor":
                    endpoint = `/advisor/subprograms/${userId}/get`;
                    break;
                case "program_officer":
                    endpoint = `/program_officer/subprograms/${userId}/get`;
                    break;
                default:
                    throw new Error("Invalid user role");
            }

            // Make the API call
            return axios
                .get(`${BASE_PATH}${endpoint}`)
                .then(response => response)
                .catch(error => {
                    console.error("API Error:", error);
                    throw error;
                });
        },

        showProjects(id) {
            this.openLoading();
            this.programId = id;
            this.trainingDiv = false;
            this.newProject.subprogram_id = id;
            this.newTraining.program_id = id;
            sessionStorage.removeItem("training");
            sessionStorage.setItem("project", id);
            axios
            this.fetchProjects(id)
                .then((response) => {
                    this.activateSubP(id)
                    this.projectData = response.data;
                    this.projectDiv = true;

                    this.closeLoading();
                })
                .catch((error) => console.error("Error fetching Projects:", error));
        },
        fetchProjects(id) {
            const BASE_PATH = localStorage.getItem("BASE_PATH");
            const userRole = this.userRole;
            const userId = this.userId;

            // Determine the endpoint based on user role
            let endpoint = "";

            switch (userRole) {
                case "admin":
                    endpoint = "/subprogram/projects/" + id + "/filter";
                    break;
                case "advisor":
                    endpoint = `/advisor/subprogram/projects/${id}/${userId}/filter`;
                    break;
                case "program_officer":
                    endpoint = `/program_officer/subprogram/projects/${id}/${userId}/filter`;
                    break;
                default:
                    throw new Error("Invalid user role");
            }

            // Make the API call
            return axios
                .get(`${BASE_PATH}${endpoint}`)
                .then(response => response)
                .catch(error => {
                    console.error("API Error:", error);
                    throw error;
                });
        },

        showTrainings(id) {
            this.openLoading();
            this.projectId = id;
            this.newTraining.project_id = id;
             sessionStorage.setItem("training", id);
            this.trainingData = [];
            this.dateRange = [];
            axios
            this.fetchTrainings(id)
                .then((response) => {
                    setTimeout(() => {
                        this.closeLoading();
                    }, 500);
                    this.trainingData = response.data;
                    this.trainingDiv = true;
                    this.activatePr(id);
                    this.closeLoading()
                })
                .catch((error) => console.error("Error fetching Trainings:", error));
        },
        fetchTrainings(id) {
            const BASE_PATH = localStorage.getItem("BASE_PATH");
            const userRole = this.userRole;
            const userId = this.userId;

            // Determine the endpoint based on user role
            let endpoint = "";

            switch (userRole) {
                case "admin":
                    endpoint = "/project/trainings/" + id + "/filter";
                    break;
                case "advisor":
                    endpoint = `/advisor/project/trainings/filterdate/01-01-2000/30-12-2028/${id}/${userId}`;
                    break;
                case "program_officer":
                    endpoint = `/project/trainings/filterdate/01-01-2000/31-12-2028/${id}/${userId}`;
                    break;
                default:
                    throw new Error("Invalid user role");
            }

            // Make the API call
            return axios
                .get(`${BASE_PATH}${endpoint}`)
                .then(response => response)
                .catch(error => {
                    console.error("API Error:", error);
                    throw error;
                });
        },
        fetchTrainingsDateRange(startDate, endDate) {
            const BASE_PATH = localStorage.getItem("BASE_PATH");
            const userRole = this.userRole;
            const userId = this.userId;
            const id = this.projectId;
            // Determine the endpoint based on user role
            let endpoint = "";

            switch (userRole) {
                case "admin":
                    endpoint = `/project/trainings/filterdate/${startDate}/${endDate}/${id}`;
                    break;
                case "advisor":
                    endpoint = `/advisor/project/trainings/filterdate/${startDate}/${endDate}/${id}/${userId}`;
                    break;
                case "program_officer":
                    endpoint = `/program_officer/project/trainings/filterdate/${startDate}/${endDate}/${id}/${userId}`;
                    break;
                default:
                    throw new Error("Invalid user role");
            }

            // Make the API call
            return axios
                .get(`${BASE_PATH}${endpoint}`)
                .then(response => response)
                .catch(error => {
                    console.error("API Error:", error);
                    throw error;
                });
        },
        
        resetTrainingFilter(id) {
            this.showTrainings(id);
            this.searchendDate = '';
            this.searchstartDate = '';
        },
        showsingletrainingreport(item) {
            const userRole = this.userRole;
            const trainingId = item.training_code;
            let path = "";

            // Determine the path based on user role
            switch (userRole) {
                case "admin":
                    path = "/dashboard/admin/training_wizard";
                    break;
                case "program_officer": // Program Officer
                    path = "/dashboard/programOfficer/wizard-completion";
                    break;
                case "advisor":
                    path = "/dashboard/advisor/training-Assignment";
                    break;
                default:
                    console.error("Invalid user role");
                    return;
            }

            // Navigate to the determined path with the training ID as a query parameter
            this.$router.push({
                path: path,
                query: {
                    trainingId: trainingId
                }
            });
        },
         getProgramofficer() {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/programofficer/get")
                .then(response => {
                    this.programOfficerArr = response.data;
                });
        },
        getAdvisor() {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/advisor/get")
                .then(response => {
                    this.advisorArr = response.data;
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
         activateSubP: function activateSubP(id) {
              this.active_sp = id;
         },
        activatePr: function activatePr(id) {
              this.active_pr = id;
         },
        activateTr: function activateTr(id) {
              this.active_tr = id;
         },
        submitSubProgram(e) {
            e.preventDefault();

            this.inValid = [];
            if (!this.newSubProgram.title) {
                this.inValid.push("Sub program is required.");
            }
            if (!this.newSubProgram.code) {
                this.inValid.push("Code is required.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(
                        localStorage.getItem("BASE_PATH") + "/sub-program/add",
                        this.newSubProgram
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            this.resetForm();
                            this.searchSubProgram();
                            this.toastSuccess(response.data.success);
                            this.$bvModal.hide('bv-modal-example')
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        this.toastError(error);
                    });
            }
        },


        openProjectModal() {
            this.projectModal = true;
        },
        cancelProject() {
            this.projectModal = false;
            this.resetForm();
        },
        submitProject(e) {
            e.preventDefault();

            this.inValid = [];
            if (!this.newProject.subprogram_id) {
                this.inValid.push("Please select Sub Program.");
            }
            if (!this.newProject.title) {
                this.inValid.push("Project title is required.");
            }
            if (!this.newProject.code) {
                this.inValid.push("Code is required.");
            }
            if (!this.newProject.startDate) {
                this.inValid.push("Start date is required.");
            }
            if (!this.newProject.endDate) {
                this.inValid.push("End date is required.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {

                this.openLoading();
                axios
                    .post(localStorage.getItem("BASE_PATH") + "/project/add", this.newProject, {
                        headers: {
                            Authorization: localStorage.getItem("token"),
                        }
                    })
                    .then(response => {

                        this.closeLoading();
                        if (response.data.success) {
                            this.cancelProject();
                            this.showProjects(this.programId);
                            this.resetForm();
                            this.toastSuccess("Record has been added successfully!");
                            this.$bvModal.hide('bv-modal-example2')
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.newSubProgram.title = '';
            this.newSubProgram.code = '';
            // this.newProject.subprogram_id = '';
            this.newProject.code = '';
            this.newProject.title = '';
            this.newProject.startDate = '';
            this.newProject.endDate = '';
            // this.newTraining.program_id = '';
            // this.newTraining.project_id = '';
            this.newTraining.trainingtitle = '';
            this.newTraining.advisor_id = '';

        },
        subProgramCSV() {
            subProgrammes(this.subProgramData)
        },
        projectCSV() {
            projects(this.projectData)
        },
        trainingCSV() {
            trainings(this.trainingData)
        },
        openTrainingModal() {
            this.trainingModal = true;
        },
        cancelTraining() {
            this.trainingModal = false;
            this.resetForm();
        },
        submitTraining(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.newTraining.program_id) {
                this.inValid.push("Please select Sub Program.");
            }
            if (!this.newTraining.project_id) {
                this.inValid.push("Please select Project.");
            }
            if (!this.newTraining.trainingtitle) {
                this.inValid.push("Please enter Training Title.");
            }
            if (!this.newTraining.advisor_id) {
                this.inValid.push("Please select Advisor.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }

            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(localStorage.getItem("BASE_PATH") + "/admin/create/training", this.newTraining

                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);

                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data.success) {
                            this.cancelTraining();
                            this.showTrainings(this.projectId);
                            this.resetForm();
                            this.toastSuccess("Record has been added successfully!");
                            this.$bvModal.hide('bv-modal-example3')
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        enddateStatusText(startDate,endDate) {
             if (!endDate) return 'End Date Missing';
             if (!startDate) return 'Start Date Missing'; // Handle missing startDate if needed

             const todayDate = new Date();
             const today = moment(todayDate, 'DD-MM-YYYY');
             const start = moment(startDate, 'DD-MM-YYYY');
             const end = moment(endDate, 'DD-MM-YYYY');

             if (today.isBetween(start, end, 'day', '[]')) {
                 return 'In Progress'; // Today is between startDate and endDate
                 }

                return end.isSameOrAfter(today) ? 'Planned' : 'Completed';
            },
         // Method to calculate the status class
         enddateStatusClass(startDate,endDate) {
           const todayDate = new Date();
             const today = moment(todayDate, 'DD-MM-YYYY');
             const start = moment(startDate, 'DD-MM-YYYY');
             const end = moment(endDate, 'DD-MM-YYYY');

             if (today.isBetween(start, end, 'day', '[]')) {
                 return 'status-in-progress';
                 }

                return end.isSameOrAfter(today) ? 'status-planned' : 'status-completed';
           },
           scrollToEnd(elementId) {
    // Remove console.logs and add longer timeout to ensure element exists
    setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ 
                behavior: 'smooth',
                block: 'end',
                duration: 5000,
            });
        }
    }, 300); // Increased timeout to 300ms
},
      scrollToSlowly(elementId) {
          setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ 
                behavior: 'smooth',
                block: 'end',
                duration: 5000,
            });
        }
    }, 300); // Increased timeout to 300ms
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },

    },
    computed: {
        subProgramFilter() {
            if (!this.searchQuerySubProgram.trim()) {
                return this.subProgramData;
            }
            return this.subProgramData.filter((item) => {
                const searchableFields = `${item.title} ${item.code} ${item.count}`;
                return searchableFields
                    .toLowerCase()
                    .includes(this.searchQuerySubProgram.toLowerCase());
            });
        },

        projectFilter() {
            if (!this.searchQueryProject.trim()) {
                return this.projectData;
            }
            return this.projectData.filter((item) => {
                const searchableFields = `${item.title} ${item.code} ${item.count}`;
                return searchableFields
                    .toLowerCase()
                    .includes(this.searchQueryProject.toLowerCase());
            });
        },

        trainingFilter() {
            if (!this.searchQueryTraining.trim()) {
                return this.trainingData;
            }
            return this.trainingData.filter((item) => {
                const searchableFields = `${item.title} ${item.days}`;
                return searchableFields
                    .toLowerCase()
                    .includes(this.searchQueryTraining.toLowerCase());
            });
        },
    },
    watch: {
        dateRange(date) {
            if (date != undefined && date != "") {
                this.searchstartDate = date.split(" to")[0];
                this.searchendDate = date.split("to ")[1];
                if (
                    this.searchstartDate != undefined &&
                    this.searchendDate != undefined
                ) {
                    this.openLoading();
                    axios

                    this.fetchTrainingsDateRange(this.searchstartDate, this.searchendDate, )
                        .then(response => {
                            this.closeLoading();
                            if (response) {
                                this.trainingData = response.data

                            }
                        });
                }
            }
        },
        projectDiv(newValue) {
        if (newValue) {
            // Add $nextTick to ensure DOM is updated
            this.$nextTick(() => {
                this.scrollToEnd('projectDiv');
            });
        }
    },
    trainingDiv(newValue) {
        if (newValue) {
            this.$nextTick(() => {
                this.scrollToSlowly('trainingDiv');
            });
        }
    }
    },
};
</script>

<style scoped>

 .modal-btn {
  padding: 0px 50px;
  height: 30px;
  border-radius: 10px;
}

ul.date-ul {
  display: inline-flex;
}
ul li {
  cursor: pointer;
}
a {
  cursor: pointer;
}

.date-ul li.start-date {
  padding-right: 35px;
}

.cards-row {
  margin-top: 10px !important;
}

.card-col {
  padding: 5px !important;
}

.main-card {
  color: #6c757d;
  border: 1px dotted #07a7e14f;
}

.main-card:hover {
  border: 1px solid #07a7e14f;
}

.training-title {
  font-weight: 500;
}

.training-title-cards {
  font-size: 15px;
  font-weight: 500;
}

.con-vs-card.withHover:hover img {
  -webkit-transform: scale(1);
  transform: scale(1);
}

.cardheader {
  display: inline-flex;
}

@media (max-width: 768px) {
  .card-col {
    width: 100% !important;
  }

  ul.date-ul {
    margin-top: 5px;
  }

  .date-ul li.start-date {
    padding-right: 26px;
  }

  .training-title {
    font-size: 14px;
  }
  .align-self-center{
    display: none
  }
  .sp{
    margin-left: 0px !important;
  }
}

@media (max-width: 991.98px) {

  .date-ul li.start-date {
    padding-right: 26px;
  }

  .card-col {
    width: 100% !important;
  }

  ul.date-ul {
    margin-top: 5px;
  }
}


.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}

.latest-update-card .card-block {
  padding-top: 0;
}

.latest-update-card .card-block .latest-update-box {
  position: relative;
}

.latest-update-card .card-block .latest-update-box:after {
  content: "";
  position: absolute;
  background: #ebebeb;
  height: 100%;
  width: 3px;
  top: 0;
  left: 19px;
  z-index: 1;
}

.latest-update-card .card-block .latest-update-box .update-meta {
  z-index: 2;
}

.latest-update-card .card-block .latest-update-box .update-meta .update-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  padding: 7px 8px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: #fff;
}

.latest-update-card .card-block .update-icon.bg-c-red {
  -webkit-box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
  box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-blue {
  -webkit-box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
  box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-green {
  -webkit-box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
  box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-yellow {
  -webkit-box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
  box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
}

.latest-update-card .card-block .update-icon.ring {
  border-width: 3px;
  width: 15px;
  height: 15px;
  padding: 0;
  display: block;
  margin-left: 13px;
  background: #fff;
}

.latest-update-card .card-block .latest-update-box .update-meta i.update-icon {
  margin-left: 4px;
  margin-right: 19px;
}

.latest-update-card .card-block .update-icon {
  padding: 0;
  width: 40px;
  height: 40px;
}

.bg-c-lite-blue {
  background: -webkit-gradient(linear-gradient(to right, #06a6e0, #00d2d6));
  background: linear-gradient(to right, #06a6e0, #00d2d6);
}

.bg-c-lite-purple {
  background: -webkit-gradient(linear-gradient(to right, #955cf9, #96a5f9));
  background: linear-gradient(to right, #955cf9, #96a5f9);
}

.bg-c-lite-pink {
  background: -webkit-gradient(linear-gradient(to right, #fe5d70, #fe909d));
  background: linear-gradient(to right, #fe5d70, #fe909d);
}

@media only screen and (max-width: 575px) {
  .latest-update-card .card-block .latest-update-box:after {
    display: none;
  }

  .latest-update-card .card-block .latest-update-box .update-meta {
    z-index: 2;
    min-width: 100%;
    text-align: left !important;
    margin-bottom: 15px;
    border-top: 1px solid #f1f1f1;
    padding-top: 15px;
  }
}

.sub-programmes {
  min-height: 80vh;
  max-height: 80vh;
  overflow: auto;
}
.sub{
  background-color: #fff2e5;
  border: 2px solid #ffdfbb;
}
.sub-card{
  background-color: #fff2e5 !important;
}
.project{
  background-color: #f9ffe6;
  border: 2px solid #d4e891;
}
.project-card{
  background-color: #f9ffe6 !important;
}
.training{
  background-color: #e6f4ff;
  border: 2px solid #9fdcf7;
}
.training-card{
  background-color: #e6f4ff !important;
}
.crd-title {
  margin-top: 10px;
}
.crd-title h5 {
  text-transform: uppercase;
}
.crd-title small b {
  font-size: 14px;
  text-transform: capitalize;
}
.clr-orange {
  color: #ef8100;
}

.clr-green {
  color: #a4c639;
}

.clr-blue {
  color: #00a4ea;
}

b {
  color: #080808;
  font-size: 13px;
}
.add-new {
  position: absolute;
  width: 90%;
  bottom: 7px;
}
.bg-clr-orange {
  background-color: #fff2e5;
  padding: 10px;
}
.bg-clr-green {
  background-color: #f9ffe6;
  padding: 10px;
}
.bg-clr-blue {
  background-color: #e6f4ff;
  padding: 10px;
}
.add-new h6 {
  color: #080808;
  font-size: 15px;
}
.list-ul {
  padding: 5px;
}

.short-title {
  padding: 0px;
  font-weight: bold;
  width: 50px;
}
.md-title {
  padding: 0px 4px;
}

.hover-on-li:hover {
  background: #eedfd1 !important;
}

.not-full {
  padding: 4px 4px !important;
}
.search_button {
  background-color: transparent !important;
  border: 1px solid #a4a8ad !important;
}
.search_button:focus {
  background-color: transparent !important;
}

/* ---------new--------- */
.card {
  padding: 1rem;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #ddd;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  width: 96%;
  margin-left: 2%;

}

.card:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.active-card {
  border: 2px solid #3C763D ;
}


.clr-orange {
  color: #ff9800;
}

.hover-on-li {
  transition: background-color 0.3s ease;
}
.title_name {
      font-size: 16px;
      font-weight: bold;
      color: #0077c0;
      margin-bottom: 5px;
    }
.details {
        font-size: 12px;
        color: #555;
       font-family: calibri;
       font-weight: bold;
     }
  .trainingCount{
      font-size: 11px;
        color: #555;
       font-family: calibri;
       font-weight: bold;
       text-decoration: underline;
     }
.status {
      display: inline-block;
      margin-top: 10px;
      padding: 5px;
      border-radius: 5px;
      color: #fff;
      font-size: 12px;
      margin-right: 5px;
    }

.status-planned {
      background-color: #7f7575;
    }

.status-completed {
      background-color: #28a745;
    }

.status-in-progress {
      background-color: #ffc107;
      color: #000;
    }
.heading {
      font-size: 18px;
      font-weight: bold;
      color: #0077c0;
      text-align: center;
      text-transform: uppercase;
      letter-spacing: 1px;
    }
.open-modal{
      font-size: 16px;
      background: #007ACC;
      color: #ffff;
      padding: 7px;
      border-radius: 5px;
      cursor: pointer;
      font-family: calibri;
      font-weight: bold;
    }
.open-modal:hover{
      color: #ffff;
      background:#0662a1f5;
    }
.date-box {
      position: relative;
    }
.date-btn {
      position: absolute;
    right: 0px;
    top: 27px;
    }

.modal-D {
    position: fixed;
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
}
.modal{
  background: rgba(0, 0, 0, 0.7);
}
.sp{
    background: #ef8100;
    padding: 10px 6px 10px 7px;
    border-radius: 50px;
    color: #ffff !important;
    margin-left: 8px;
}
/* Fade-in/out effect */
.slide-enter-active, .slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter {
  transform: translateX(100%);
  opacity: 0;
}
.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.title_code{
      font-size: 16px;
      font-weight: bold;
      color: #ef8100;
}
</style>

